(() => {
  const config = document.getElementById('pp-currency-config');
  if (!config) return;
  const labels = JSON.parse(config.textContent);
  const currencies = ['ILS', 'USD', 'EUR', 'GBP'];
  const preferenceKey = 'pp_display_currency_v1';
  const ratesKey = 'pp_display_fx_v1';
  const day = 86400000;
  let currency = 'ILS';
  let rates;
  let pending;
  let status = '';
  try { currency = localStorage.getItem(preferenceKey) || 'ILS'; } catch (_) {}
  if (!currencies.includes(currency)) currency = 'ILS';

  function validRates(value) {
    if (!value || !Array.isArray(value.rows) || value.rows.length !== 3) return false;
    return currencies.slice(1).every(code => {
      const row = value.rows.find(item => item.quote === code);
      if (!row || row.base !== 'ILS' || typeof row.rate !== 'number' || !Number.isFinite(row.rate) || row.rate <= 0) return false;
      if (!/^\d{4}-\d{2}-\d{2}$/.test(row.date)) return false;
      const age = Date.now() - Date.parse(`${row.date}T00:00:00Z`);
      return Number.isFinite(age) && age >= -day && age <= 7 * day;
    });
  }

  async function loadRates() {
    if (validRates(rates) && Date.now() - rates.fetchedAt < day) return;
    if (pending) return pending;
    try {
      const cached = JSON.parse(localStorage.getItem(ratesKey));
      if (validRates(cached)) rates = cached;
    } catch (_) {}
    if (validRates(rates) && Date.now() - rates.fetchedAt < day) return;
    pending = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const response = await fetch('https://api.frankfurter.dev/v2/rates?base=ils&quotes=usd,eur,gbp', { credentials: 'omit', referrerPolicy: 'no-referrer', signal: controller.signal });
        if (!response.ok) throw new Error('Rates unavailable');
        const next = { fetchedAt: Date.now(), rows: await response.json() };
        if (!validRates(next)) throw new Error('Invalid rates');
        rates = next;
        try { localStorage.setItem(ratesKey, JSON.stringify(rates)); } catch (_) {}
      } catch (error) {
        if (!validRates(rates)) throw error;
      } finally {
        clearTimeout(timeout);
        pending = null;
      }
    })();
    return pending;
  }

  function updatePrices() {
    document.querySelectorAll('pp-converted-price').forEach(price => price.render());
    document.querySelectorAll('pp-currency-notice').forEach(notice => { notice.hidden = currency === 'ILS' || !validRates(rates); });
    document.querySelectorAll('pp-display-currency').forEach(picker => picker.render());
  }

  async function selectCurrency(next) {
    if (!currencies.includes(next)) return;
    currency = next;
    status = currency === 'ILS' ? '' : labels.loading;
    updatePrices();
    if (currency !== 'ILS') {
      try {
        await loadRates();
        status = '';
      } catch (_) {
        currency = 'ILS';
        status = labels.unavailable;
      }
    }
    try { localStorage.setItem(preferenceKey, currency); } catch (_) {}
    updatePrices();
  }

  class ConvertedPrice extends HTMLElement {
    static get observedAttributes() { return ['data-ils-cents', 'data-max-ils-cents', 'data-from']; }
    connectedCallback() { this.render(); }
    attributeChangedCallback() { this.render(); }
    render() {
      const cents = Number(this.dataset.ilsCents);
      this.hidden = currency === 'ILS' || !validRates(rates) || !this.hasAttribute('data-ils-cents') || !Number.isInteger(cents) || cents < 0;
      if (this.hidden) { this.textContent = ''; return; }
      const rate = rates.rows.find(row => row.quote === currency).rate;
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'code' });
      let value = formatter.format(cents / 100 * rate);
      const max = Number(this.dataset.maxIlsCents);
      if (Number.isInteger(max) && max > cents) value += ` – ${formatter.format(max / 100 * rate)}`;
      if (this.dataset.from === 'true') value = `${labels.from} ${value}`;
      this.textContent = `≈ ${value}`;
      this.title = labels.note;
    }
  }

  class CurrencyPicker extends HTMLElement {
    connectedCallback() {
      if (!this.initialized) {
        this.initialized = true;
        this.querySelector('select').addEventListener('change', event => selectCurrency(event.target.value));
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.querySelector('details')) {
            this.querySelector('details').open = false;
            this.querySelector('summary').focus();
          }
        });
      }
      this.render();
    }
    render() {
      this.querySelector('select').value = currency;
      const label = this.querySelector('[data-currency-label]');
      const approximate = this.querySelector('[data-currency-approx]');
      if (label) label.textContent = currency;
      if (approximate) approximate.hidden = currency === 'ILS';
      this.querySelector('[data-currency-status]').textContent = status;
      const row = validRates(rates) && rates.rows.find(item => item.quote === currency);
      this.querySelector('[data-currency-source]').hidden = !row;
      this.querySelector('[data-currency-date]').textContent = row ? new Intl.DateTimeFormat(document.documentElement.lang || 'en').format(new Date(`${row.date}T12:00:00Z`)) : '';
    }
  }

  class CurrencyNotice extends HTMLElement {
    connectedCallback() { this.hidden = currency === 'ILS' || !validRates(rates); }
  }
  customElements.define('pp-converted-price', ConvertedPrice);
  customElements.define('pp-display-currency', CurrencyPicker);
  customElements.define('pp-currency-notice', CurrencyNotice);
  if (currency !== 'ILS') selectCurrency(currency);
})();
